export const isAdminRole = (role) => role === "contracts_Admin" || role === "contracts_OrgAdmin";

const BASE_ITEMS = [
  {
    key: "dashboard",
    labelKey: "sidebar.Dashboard",
    fallbackLabel: "Dashboard",
    to: "/dashboard/35KBoSgoAK",
    icon: "home"
  },
  {
    key: "request-signatures",
    labelKey: "sidebar.Request signatures",
    fallbackLabel: "Request signatures",
    to: "/form/8mZzFxbG1z",
    icon: "mail"
  },
  {
    key: "templates",
    labelKey: "sidebar.Templates",
    fallbackLabel: "Templates",
    icon: "layout",
    children: [
      {
        key: "create-template",
        labelKey: "sidebar.Templates-Children.Create template",
        fallbackLabel: "Create template",
        to: "/form/template",
        icon: "layout"
      },
      {
        key: "manage-templates",
        labelKey: "sidebar.Templates-Children.Manage templates",
        fallbackLabel: "Manage templates",
        to: "/report/6TeaPr321t",
        icon: "chart"
      }
    ]
  },
  {
    key: "drive",
    labelKey: "sidebar.DANAsign Drive",
    fallbackLabel: "DANASign Drive",
    to: "/drive",
    icon: "folder"
  },
  {
    key: "documents",
    labelKey: "new-ui.sidebar.history",
    fallbackLabel: "History",
    icon: "timeline",
    children: [
      {
        key: "need-sign",
        labelKey: "sidebar.Documents-Children.Need your sign",
        fallbackLabel: "Need your sign",
        to: "/report/4Hhwbp482K",
        icon: "signature"
      },
      {
        key: "in-progress",
        labelKey: "sidebar.Documents-Children.In Progress",
        fallbackLabel: "In Progress",
        to: "/report/1MwEuxLEkF",
        icon: "flow"
      },
      {
        key: "completed",
        labelKey: "sidebar.Documents-Children.Completed",
        fallbackLabel: "Completed",
        to: "/report/kQUoW4hUXz",
        icon: "check"
      },
      {
        key: "drafts",
        labelKey: "sidebar.Documents-Children.Drafts",
        fallbackLabel: "Drafts",
        to: "/report/ByHuevtCFY",
        icon: "layout"
      },
      {
        key: "declined",
        labelKey: "sidebar.Documents-Children.Declined",
        fallbackLabel: "Declined",
        to: "/report/UPr2Fm5WY3",
        icon: "close"
      },
      {
        key: "expired",
        labelKey: "sidebar.Documents-Children.Expired",
        fallbackLabel: "Expired",
        to: "/report/zNqBHXHsYH",
        icon: "clock"
      }
    ]
  },
  {
    key: "contactbook",
    labelKey: "sidebar.Contactbook",
    fallbackLabel: "Contactbook",
    icon: "addressBook",
    children: [
      {
        key: "create-contact",
        labelKey: "sidebar.Contactbook-Children.Create contact",
        fallbackLabel: "Create contact",
        to: "/report/contacts?action=create",
        icon: "plus"
      },
      {
        key: "manage-contacts",
        labelKey: "sidebar.Contactbook-Children.Manage contacts",
        fallbackLabel: "Manage contacts",
        to: "/report/contacts",
        icon: "addressBook"
      }
    ]
  },
  {
    key: "sign-yourself",
    labelKey: "sidebar.Sign yourself",
    fallbackLabel: "Sign yourself",
    to: "/form/sHAnZphf69",
    icon: "signature"
  }
];

const SETTINGS_ADMIN = [
  {
    key: "preferences",
    labelKey: "new-ui.settings.global-configuration-label",
    fallbackLabel: "Configuration",
    to: "/preferences",
    icon: "sliders"
  },
  {
    key: "users",
    labelKey: "sidebar.Settings-Children.Users",
    fallbackLabel: "Users",
    to: "/users",
    icon: "users"
  },
  {
    key: "certificates",
    labelKey: "sidebar.Settings-Children.Certificates",
    fallbackLabel: "Certificates",
    to: "/admin/certificates",
    icon: "shield"
  }
];

const APP_NAME = "DANASign";

const translateMenu = (items, t) =>
  items.map((item) => ({
    ...item,
    label: t(item.labelKey, { defaultValue: item.fallbackLabel, appName: APP_NAME }),
    children: item.children ? translateMenu(item.children, t) : undefined
  }));

export const getMenuItems = (role, t) => {
  let allItems = [...BASE_ITEMS];
  const canManageTemplates = role !== "contracts_User";

  if (!canManageTemplates) {
    allItems = allItems.map((item) => {
      if (item.key !== "templates" || !Array.isArray(item.children)) {
        return item;
      }
      return {
        ...item,
        children: item.children.filter((child) => child.key !== "create-template")
      };
    });
  }

  if (isAdminRole(role)) {
    allItems.push({
      key: "settings",
      labelKey: "new-ui.sidebar.configuration",
      fallbackLabel: "Configuration",
      icon: "settings",
      children: SETTINGS_ADMIN
    });
  }

  if (typeof t !== "function") {
    return allItems;
  }

  return translateMenu(allItems, t);
};

export const reportViewById = {
  "4Hhwbp482K": {
    key: "sidebar.Documents-Children.Need your sign",
    defaultValue: "Need your sign"
  },
  "1MwEuxLEkF": {
    key: "new-ui.history.in-progress-sent-by-you",
    defaultValue: "In Progress sent by you"
  },
  kQUoW4hUXz: {
    key: "sidebar.Documents-Children.Completed",
    defaultValue: "Completed"
  },
  ByHuevtCFY: {
    key: "sidebar.Documents-Children.Drafts",
    defaultValue: "Drafts"
  },
  UPr2Fm5WY3: {
    key: "sidebar.Documents-Children.Declined",
    defaultValue: "Declined"
  },
  zNqBHXHsYH: {
    key: "sidebar.Documents-Children.Expired",
    defaultValue: "Expired"
  },
  "6TeaPr321t": {
    key: "sidebar.Templates",
    defaultValue: "Templates"
  },
  contacts: {
    key: "sidebar.Contactbook",
    defaultValue: "Contactbook"
  }
};
